import React from 'react';
import { Check } from 'lucide-react';
interface PackageCardProps {
  title: string;
  price: string;
  originalPrice?: string;
  description: string;
  features: string[];
  popular?: boolean;
  saving?: string;
  link: string;
}
const PackageCard: React.FC<PackageCardProps> = ({
  title,
  price,
  originalPrice,
  description,
  features,
  popular = false,
  saving,
  link
}) => {
  return <div className={`
      bg-white rounded-lg shadow-lg overflow-hidden border-2
      ${popular ? 'border-burgundy-500 transform scale-105 md:scale-110' : 'border-pink-300'}
    `} data-id="element-265">
      {popular && <div className="bg-burgundy-600 text-white text-center py-2 font-medium" data-id="element-266">
          Most Popular
        </div>}
      <div className="p-6" data-id="element-267">
        <h3 className="text-xl font-bold mb-2" data-id="element-268">{title}</h3>
        <div className="flex items-baseline mb-4" data-id="element-269">
          <span className="text-3xl font-bold" data-id="element-270">{price}</span>
          {originalPrice && <span className="ml-2 text-gray-500 line-through" data-id="element-271">
              {originalPrice}
            </span>}
        </div>
        {saving && <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium inline-block mb-4" data-id="element-272">
            Save {saving}
          </div>}
        <p className="text-gray-600 mb-6" data-id="element-273">{description}</p>
        <ul className="space-y-2 mb-6" data-id="element-274">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-275">
              <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-276" />
              <span data-id="element-277">{feature}</span>
            </li>)}
        </ul>
        <a href={link} target="_blank" rel="noopener noreferrer" className={`
            block w-full text-center py-2 rounded-md font-medium transition-colors
            ${popular ? 'bg-burgundy-600 hover:bg-burgundy-700 text-white' : 'bg-burgundy-400 hover:bg-burgundy-500 text-white'}
          `} data-id="element-278">
          Book Now
        </a>
      </div>
    </div>;
};
export default PackageCard;